/**
 * Tasks module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// Tasks pages
const TasksListPage = lazyWithRetry(() => import('@/features/tasks/pages/TasksListPage'));
const TaskDetailsPage = lazyWithRetry(() => import('@/features/tasks/pages/TaskDetailsPage'));
const TaskCreatePage = lazyWithRetry(() => import('@/features/tasks/pages/TaskCreatePage'));
const TaskEditPage = lazyWithRetry(() => import('@/features/tasks/pages/TaskEditPage'));

export const tasksRoutes: RouteObject[] = [
      // --------------------------------
      // Tasks Module
      // --------------------------------
      {
        path: ROUTES.tasks.list,
        element: (
          <PermissionRoute anyOf={[PK.Tasks.ViewOwn, PK.Tasks.ViewAll]}>
            <TasksListPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.tasks.create,
        element: (
          <PermissionRoute permission={PK.Tasks.Create}>
            <TaskCreatePage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.tasks.details,
        element: (
          <PermissionRoute anyOf={[PK.Tasks.ViewOwn, PK.Tasks.ViewAll]}>
            <TaskDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.tasks.edit,
        element: (
          <PermissionRoute permission={PK.Tasks.Edit}>
            <TaskEditPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.tasks.report,
        element: (
          <PermissionRoute permission={PK.Tasks.ReportView}>
            <TaskDetailsPage />
          </PermissionRoute>
        ),
      },
];
